import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from './api'

export default function Tenants({ onExpired }) {
  const { t, i18n } = useTranslation()
  const [query, setQuery] = useState('')
  const [rows, setRows] = useState([])
  const [error, setError] = useState(null)

  // Typed queries wait a beat, so the server sees words rather than keystrokes.
  useEffect(() => {
    const timer = setTimeout(() => {
      api
        .tenants(query)
        .then((result) => {
          setRows(result)
          setError(null)
        })
        .catch((failure) => {
          onExpired(failure)
          setError(failure.message)
        })
    }, 250)

    return () => clearTimeout(timer)
  }, [query, onExpired])

  return (
    <section className="card">
      <input
        type="search"
        className="search"
        placeholder={t('tenants.search')}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />

      {error && <p className="status bad">{error}</p>}
      {rows.length === 0 && !error && <p className="muted">{t('tenants.empty')}</p>}

      {rows.length > 0 && (
        <div className="scroll">
          <table>
            <thead>
              <tr>
                <th>{t('tenants.name')}</th>
                <th>{t('tenants.users')}</th>
                <th>{t('tenants.sites')}</th>
                <th className="num">{t('tenants.posts')}</th>
                <th className="num">{t('tenants.balance')}</th>
                <th>{t('tenants.created')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <a href={`#/tenant/${row.id}`}>{row.name}</a>
                  </td>
                  <td className="small">{row.users.join(', ')}</td>
                  <td className="small">{row.sites.join(', ')}</td>
                  <td className="num">{row.posts}</td>
                  <td className="num">{row.balance}</td>
                  <td className="small">{new Date(row.createdAt).toLocaleDateString(i18n.language)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
